import { CircularProgress, type CircularProgressProps } from '@mui/material';

type MenuItemLoadingIndicatorProps = {
  color?: CircularProgressProps['color'];
};

const MenuItemLoadingIndicator = (props: MenuItemLoadingIndicatorProps) => (
  <CircularProgress size={18} color="secondary" {...props} />
);

export default MenuItemLoadingIndicator;
